// Port of api/fuel/app/classes/insights/collection/designer.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'
import Designer from 'offline/model/designer'

export default Segment.extend({
    name: 'designer',
    insight: false,
    default_: false,
    run: function(type, owner, userIndex, detail, filter, vars) {

        var collectedIndex = Util.queryFast('\
            SELECT \
                g.game_id \
            FROM \
                ( \
                    game_designer l \
                    JOIN \
                    collection c \
                    ON \
                    c.game_id = l.game_id \
                    AND \
                    c.collection_own = 1 \
                    AND \
                    c.user_id IN (' + Util.in(userIndex) + ') \
                    AND \
                    l.designer_id = ' + vars.id + ' \
                ) \
                JOIN \
                game g \
                ON \
                c.game_id = g.game_id \
                AND \
                g.game_type = 1 \
            GROUP BY \
                g.game_id \
            ORDER BY \
                g.game_name ASC \
        ', null, 'game_id')

        var collectedIds = Object.keys(collectedIndex)

        var ratings = Util.queryFast('\
            SELECT \
                COUNT(r.rating_id) AS count, \
                AVG(r.rating_value) AS avg, \
                r.game_id AS game_id \
            FROM \
                rating r \
            WHERE \
                r.game_id IN (' + Util.in(collectedIds) + ') \
                AND \
                r.user_id IN (' + Util.in(userIndex) + ') \
            GROUP BY \
                r.game_id \
        ', null, 'game_id')

        var games = []

        for (var i = 0; i < collectedIds.length; i++) {
            var game_id = collectedIds[i]

            this._references.games.push(game_id)

            games.push({
                id: game_id,
                count: (ratings[game_id] !== undefined) ? parseFloat(ratings[game_id].count) : 0,
                rating: (ratings[game_id] !== undefined) ? Math.round(parseFloat(ratings[game_id].avg) * 10) / 10 : 0
            })
        }

        var designer = Designer.with_id(vars.id)

        return {
            designer: designer ? designer.get_name() : '',
            games: games
        }

    }
})
